import { url } from "@frontend/lib/http";

const SIZE = { width: 1400, height: 800 };

function openWindow(href: string, title: string): void {
  const width = SIZE.width + 32;
  const height = SIZE.height + 96;

  window
    .open(
      href,
      title,
      `width=${width},height=${height},location=no,menubar=no,status=no,` +
        "toolbar=no,scrollbars=no,resizable=no",
    )
    ?.focus();
}

/** The planning, on the week of the intervention, with its first slot selected. */
export function schedulerUrl(interventionId: number): string {
  return url(
    "ecopro_project_intervention_scheduler",
    {},
    { intervention: interventionId },
  );
}

export function openHoursValidation(projectId: number, title: string): void {
  openWindow(
    url("azuris_hours_validate_project", { id: projectId }, { unlock: 0 }),
    title,
  );
}

/**
 * The dates are left out: the route defaults them itself, to the
 * intervention's own duration or, for a subscription, last calendar month.
 * The summary panel can then change either default, or whatever was passed
 * here, from its own date pickers.
 */
export function openHoursSummary(projectId: number, title: string): void {
  openWindow(url("ecopro_project_getvalidatedhours", { id: projectId }), title);
}
